import { FaDownload, FaEllipsisH, FaFilter, FaUpload } from 'react-icons/fa';
import * as XLSX from 'xlsx';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DeliveryListe.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBoxOpen, FaCalendarAlt, FaCheckCircle, FaClock, FaEdit, FaFileExport, FaFileInvoice, FaFilePdf, FaInfoCircle, FaMoneyBillWave, FaPlus, FaScrewdriver, FaSearch, FaTrash, FaTruck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { devisActions } from '../../sagas/devisSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import BonLivraisonForm from './BonLivraisonForm';
import InvoiceForm from './InvoiceForm';
import Select from "react-select";
import { clientActions } from '../../sagas/clientSlice';
import { commercialActions } from '../../sagas/commercialSlice';
import { generateDoc } from '../../helpers/generateDoc';

const DeliveryList = () => {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.deliveryNotes);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedBonLivraison, setSelectedBonLivraison] = useState(null);
    const [checkedDeliveries, setCheckedDeliveries] = useState([]); // State to track checked deliveries
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const clients = useSelector(state => state.clients.clients);
    const { list: commercialList, loading: commercialLoading } = useSelector((state) => state.commercials); // Adjust state path as needed
    const { company, businessName, email, address, telephone } = useSelector(state => state.auth);

    const fileInputRef = useRef(null);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        commercialId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        regle: -1, //0 non, 1 oui, -1 tous
        query: '',
        status: "",
    });
    const [selectedClient, setSelectedClient] = useState(null);

    const searchInputRef = useRef(null);

    const reglementOptions = [
        { value: -1, label: t('common.all', 'Tous') },
        { value: 0, label: t('reglement.nonRegle', 'Non réglé') },
        { value: 1, label: t('reglement.regle', 'Réglé') },
    ];

    const statusOptions = [
        { value: "", label: t('common.all', 'Tous') },
        { value: "EN_PREPARATION", label: 'En préparation' },
        { value: "LIVRE", label: 'Livré' },
    ];

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
        dispatch(commercialActions.list({ query: "" })); // Fetch categories on component mount
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    }, [filters.regle, filters.status, filters.clientId, filters.chantierId, filters.dateFrom, filters.dateTo, filters.commercialId]);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    // Handle checkbox change for delivery selection
    const handleCheckboxChange = (deliveryId) => {
        setCheckedDeliveries((prevChecked) => {
            if (prevChecked.includes(deliveryId)) {
                return prevChecked.filter((id) => id !== deliveryId);
            } else {
                return [...prevChecked, deliveryId];
            }
        });
    };

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            commercialId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate),
            regle: -1
        });
        debouncedSearch('')
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const refrechBLs = () => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const commercialOptions = commercialList?.map(com => ({
        value: com.id,
        label: com.fullName,
    })) ?? [];

    const commercialOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...commercialOptions
    ];

    // Handle creating an invoice from selected deliveries
    const handleCreateInvoice = () => {
        if (checkedDeliveries.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.noDeliveriesSelected'),
            });
            return;
        }

        // Get the selected delivery notes
        const selectedDeliveryNotes = list.filter(note => checkedDeliveries.includes(note.id));

        // Check if all selected delivery notes are from the same client and are in confirmed state
        const firstClient = selectedDeliveryNotes[0].clientId;
        const allSameClient = selectedDeliveryNotes.every(note => note.clientId === firstClient);
        const allConfirmed = selectedDeliveryNotes.every(note => note.status === 'LIVRE');

        if (!allSameClient) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notesFromDifferentClients'),
            });
            return;
        }



        if (!allConfirmed) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notAllDelivered'),
            });
            return;
        }

        // Prepare the invoice object
        const newInvoice = {
            clientId: selectedDeliveryNotes[0].clientId,
            clientNom: selectedDeliveryNotes[0].clientNom,
            deliveryMappings: selectedDeliveryNotes.map(note => ({
                id: note.id,
                numero: note.numero,
                dateLivraison: note.dateLivraison,
                montantTTC: note.montantTotalTTC,
                montantPaye: note.montantPaye
            })),
            lignes: (() => {
                const lineMap = {};

                selectedDeliveryNotes.forEach(note => {
                    note.lignes.forEach(line => {

                        const prixTTC = Number(line.prixUnitaireTTC || 0);
                        const tva = line.tauxTVA;

                        // Unique key = article + TTC price
                        const key = `${line.articleId}-${prixTTC}`;

                        if (!lineMap[key]) {
                            lineMap[key] = {
                                articleId: line.articleId,
                                articleCode: line.articleCode,
                                articleNom: line.articleNom,
                                unite: line.unite,
                                prixUnitaireHT: line.prixUnitaireHT,
                                prixUnitaireTTC: prixTTC,
                                tauxTVA: tva,
                                quantite: 0,
                                montantHT: 0,
                                montantTVA: 0,
                                montantTTC: 0,
                            };
                        }

                        const qty = Number(line.quantiteLivree || 0);
                        const puHT = Number(line.prixUnitaireHT || 0);

                        // accumulate
                        lineMap[key].quantite += qty;
                        lineMap[key].montantHT += line.montantHT;
                        lineMap[key].montantTVA += line.montantTVA;
                        lineMap[key].montantTTC += line.montantTTC;
                    });
                });

                return Object.values(lineMap);
            })(),

            montantTotalHT: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalHT, 0),
            montantTotalTaxe: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalTaxe, 0),
            montantTotalTTC: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalTTC, 0),
            montantTotalPaye: selectedDeliveryNotes.reduce((total, note) => total + (note.montantPaye || 0), 0),
            montantRegle: selectedDeliveryNotes.reduce((total, note) => total + (note.montantPaye || 0), 0),
            modePaiement: selectedDeliveryNotes[0].modePaiement,
            modeReglement: selectedDeliveryNotes[0].modeReglement,
            dateFacture: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }), // Current date in YYYY-MM-DD format
            dateEcheance: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }), // Current date in YYYY-MM-DD format
            // dateEcheanceCheque: selectedDeliveryNotes[0].dateEcheanceCheque,
            // banque: selectedDeliveryNotes[0].banque,
            // numeroCheque: selectedDeliveryNotes[0].numeroCheque,
        };

        setInvoice(newInvoice);
        setShowInvoiceModal(true);
    };


    const handleCloseInvoiceModal = () => {
        setShowInvoiceModal(false);
        setInvoice(null);
        setCheckedDeliveries([]); // Clear checked deliveries after closing the invoice modal
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const getModeReglementLabel = (mode) => {
        switch (mode) {
            case 'ESPECES': return 'Espèces';
            case 'CARTE_BANCAIRE': return 'Carte bancaire';
            case 'CHEQUE': return 'Chèque';
            case 'VIREMENT': return 'Virement';
            case 'TRAITE': return 'Traite';
            default: return mode || '-';
        }
    };

    const formatClientSolde = (totalDebit, totalCredit) => {
        const debit = Number(totalDebit || 0);
        const credit = Number(totalCredit || 0);

        // RÈGLE MÉTIER : crédit - débit
        const solde = credit - debit;

        const sign = solde > 0 ? '+' : solde < 0 ? '-' : '';
        return `${sign}${formatPrice(Math.abs(solde), false)}`;
    };

    const handleGeneratePdf = async (
        document,
        documentType = 'bon_livraison',
        withPrices = true,
        format = "A4"
    ) => {

        if (format === "TH") {
            await generateThermiquePDF(document)
        } else {
            await generateDoc(documentType, {
                matjarDoc: document,
                sellerModel: company,
                currency: "MAD",

                showPrices: withPrices,
                format,           // ✅ A4 | A5

                open: true,
                download: false,
            });
        }

    };

    const generateThermiquePDF = async (receiptData) => {
        console.log(receiptData)
        try {
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [80, 350], // slightly taller for bigger fonts
            });

            const pageWidth = 80;
            const margin = 4;
            let y = 8;

            /* ================= HEADER ================= */
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(18);

            const companyTitle = businessName || 'MATJARPOS';
            const titleLines = doc.splitTextToSize(
                companyTitle,
                pageWidth - margin * 2
            );

            titleLines.forEach((line, index) => {
                doc.text(line, pageWidth / 2, y + index * 7, { align: 'center' });
            });

            y += titleLines.length * 7 + 3;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);

            if (address) {
                const lines = doc.splitTextToSize(address, pageWidth - margin * 2);
                lines.forEach((l, i) =>
                    doc.text(l, pageWidth / 2, y + i * 5, { align: 'center' })
                );
                y += lines.length * 5;
            }

            if (telephone) {
                doc.text(telephone, pageWidth / 2, y + 5, { align: 'center' });
                y += 8;
            }

            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            /* ================= INFO ================= */
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.text('REÇU DE VENTE', pageWidth / 2, y, { align: 'center' });
            y += 7;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);

            doc.text(`N° : ${receiptData?.numero || '-'}`, margin, y);
            y += 6;
            doc.text(`Date : ${receiptData?.createdAt || '-'}`, margin, y);
            y += 6;

            doc.text(`Vendeur : ${receiptData?.createdBy || '---'}`, margin, y);
            y += 6;

            doc.text(`Client : ${receiptData?.clientNom || 'Passager'}`, margin, y);
            y += 6;

            doc.line(margin, y, pageWidth - margin, y);
            y += 5;

            /* ================= ARTICLES HEADER ================= */
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);

            doc.text('Article', margin, y);
            doc.text('Qté', pageWidth - 42, y, { align: 'center' });
            doc.text('PU', pageWidth - 26, y, { align: 'right' });
            doc.text('Total', pageWidth - margin, y, { align: 'right' });

            y += 4;
            doc.line(margin, y, pageWidth - margin, y);
            y += 4;

            /* ================= ARTICLES LINES ================= */
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);

            receiptData?.lignes?.forEach(item => {
                const name =
                    item.articleNom.length > 20
                        ? item.articleNom.slice(0, 20) + '…'
                        : item.articleNom;

                const qte = Number(item.quantiteLivree || 0);
                const pu = Number(item.prixUnitaireTTC || 0);
                const total = Number(item.montantTTC || qte * pu);

                doc.text(name, margin, y);
                doc.text(String(qte), pageWidth - 42, y, { align: 'center' });
                doc.text(formatPrice(pu, false), pageWidth - 26, y, { align: 'right' });
                doc.text(formatPrice(total, false), pageWidth - margin, y, {
                    align: 'right',
                });

                y += 7;
            });

            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            /* ================= TOTAL ================= */
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(14);

            doc.text('TOTAL TTC', margin, y);
            doc.text(
                formatPrice(receiptData?.montantTotalTTC, false),
                pageWidth - margin,
                y,
                { align: 'right' }
            );

            y += 8;
            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            /* ================= PAIEMENT ================= */
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);

            const modeLabel = getModeReglementLabel(receiptData?.modeReglement);
            doc.text(`Mode paiement : ${modeLabel}`, margin, y);
            y += 6;

            doc.text('Montant payé :', margin, y);
            doc.text(
                formatPrice(receiptData?.montantPaye, false),
                pageWidth - margin,
                y,
                { align: 'right' }
            );
            y += 6;

            if (
                receiptData?.modeReglement === 'ESPECES' &&
                receiptData?.montantPaye > receiptData?.montantTotalTTC
            ) {
                doc.text('Monnaie :', margin, y);
                doc.text(
                    formatPrice(
                        receiptData.montantPaye - receiptData.montantTotalTTC,
                        false
                    ),
                    pageWidth - margin,
                    y,
                    { align: 'right' }
                );
                y += 6;
            }

            doc.line(margin, y, pageWidth - margin, y);
            y += 7;

            /* ================= SOLDE CLIENT ================= */
            if (
                !receiptData?.isComptoir &&
                receiptData?.clientTotalDebit &&
                receiptData?.clientTotalCredit
            ) {
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(12);
                doc.text('SOLDE CLIENT', margin, y);

                doc.setFont('helvetica', 'normal');
                doc.text(
                    formatClientSolde(
                        receiptData.clientTotalDebit,
                        receiptData.clientTotalCredit
                    ),
                    pageWidth - margin,
                    y,
                    { align: 'right' }
                );
                y += 8;
            }

            /* ================= FOOTER ================= */
            doc.setFontSize(11);
            doc.text('Merci de votre confiance', pageWidth / 2, y, {
                align: 'center',
            });
            y += 6;

            doc.text('Powered by MatjarPOS', pageWidth / 2, y, {
                align: 'center',
            });

            const blobUrl = doc.output('bloburl');
            window.open(blobUrl, '_blank');
        } catch (e) {
            console.error(e);
        }
    };



    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleEdit = (bl) => {
        setSelectedBonLivraison(bl);
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        if (selectedBonLivraison) {
            setSelectedBonLivraison(null);
        }
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const debouncedSearch = () => {
        dispatch(deliveryActions.list({
            ...filters,
        }));
    }

    const handleLivrerBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmLivrer'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, status: 'LIVRE' },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                    };
                    dispatch(deliveryActions.list(payload));

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    const handleAccuseBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmAccuser'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, accuse: true },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                    };
                    dispatch(deliveryActions.list(payload));

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    // Aggregate lines by articleId for display/export
    const aggregateLines = (lines) => {
        const lineMap = {};
        lines.forEach(line => {
            const key = line.articleId;
            if (!lineMap[key]) {
                lineMap[key] = {
                    ...line,
                    quantite: 0,
                    montantHT: 0,
                    montantTVA: 0,
                    montantTTC: 0,
                };
            }
            lineMap[key].quantite += line.quantite;
            lineMap[key].montantHT += line.montantHT || (line.quantite * line.prixUnitaireHT);
            lineMap[key].montantTVA += line.montantTVA || (line.quantite * line.prixUnitaireHT * line.tauxTVA);
            lineMap[key].montantTTC += line.montantTTC || (line.quantite * line.prixUnitaireHT * (1 + line.tauxTVA));
        });
        return Object.values(lineMap);
    };

    const handleAnnulerBL = (br) => {
        Swal.fire({
            title: t('delivery.deleteConfirmTitle'),
            text: t('delivery.deleteConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    let payload = {
                        id: br.id,
                        onSuccess: () => {
                            Swal.fire(t('delivery.deleted'), '', 'success');
                            refrechBLs();
                        },
                        onError: (error) => {
                            Swal.fire({
                                icon: 'error',
                                title: t('delivery.deleteError'),
                                text: t('delivery.deleteErrorMessage')
                            });
                        }
                    }
                    dispatch(deliveryActions.annulerBL(payload));

                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: t('common.error'),
                        text: t('delivery.deleteError')
                    });
                }
            }
        });
    }

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaTruck className="text-primary me-2" />
                                {t('delivery.list')}
                            </h4>
                            <div className="d-flex align-items-center gap-2">
                                {/* Primary actions */}
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="me-2" /> {t('delivery.new')}
                                </Button>
                                {checkedDeliveries.length > 0 && (
                                    <Button color="success" onClick={handleCreateInvoice}>
                                        <FaFileInvoice className="me-2" />
                                        {t('delivery.createInvoice')}
                                    </Button>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="g-3 align-items-end">

                                    {/* 🔍 SEARCH */}
                                    <Col xl={2} lg={3} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('common.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('bonLivraison.searchPlaceholder')}
                                                    value={filters.query}
                                                    className="text-uppercase"
                                                    onChange={e =>
                                                        setFilters(f => ({ ...f, query: e.target.value.toUpperCase() }))
                                                    }
                                                    onKeyDown={e => e.key === 'Enter' && debouncedSearch()}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>

                                    {/* 👤 CLIENT */}
                                    <Col xl={2} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('bonLivraison.client')}</Label>
                                            <Select
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(o => o.value === filters.clientId)}
                                                onChange={o => {
                                                    setFilters(f => ({ ...f, clientId: o?.value ?? null }));
                                                    setSelectedClient(o);
                                                }}
                                                isClearable
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 🏗️ CHANTIER */}
                                    <Col xl={2} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('chantier.title', 'Chantier')}</Label>
                                            <Select
                                                options={chantierOptionsWithAll}
                                                value={chantierOptionsWithAll.find(o => o.value === filters.chantierId)}
                                                onChange={o =>
                                                    setFilters(f => ({ ...f, chantierId: o?.value ?? null }))
                                                }
                                                isClearable
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 👔 COMMERCIAL */}
                                    <Col xl={2} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('commercial.title', 'Commercial')}</Label>
                                            <Select
                                                options={commercialOptionsWithAll}
                                                value={commercialOptionsWithAll.find(o => o.value === filters.commercialId)}
                                                onChange={o =>
                                                    setFilters(f => ({ ...f, commercialId: o?.value ?? null }))
                                                }
                                                isClearable
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 💰 STATUT PAIEMENT */}
                                    <Col xl={1} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.status', 'Paiement')}</Label>
                                            <Input
                                                type="select"
                                                value={filters.regle}
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, regle: e.target.value }))
                                                }
                                            >
                                                {reglementOptions.map(opt => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col xl={1} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">Status</Label>
                                            <Input
                                                type="select"
                                                value={filters.status}
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, status: e.target.value }))
                                                }
                                            >
                                                {statusOptions.map(opt => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>

                                    {/* 📅 DATE FROM */}
                                    <Col xl={1} lg={2} md={3}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('common.from', 'Du')}</Label>
                                            <Input
                                                type="date"
                                                value={filters.dateFrom}
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, dateFrom: e.target.value }))
                                                }
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 📅 DATE TO */}
                                    <Col xl={1} lg={2} md={3}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('common.to', 'Au')}</Label>
                                            <Input
                                                type="date"
                                                value={filters.dateTo}
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, dateTo: e.target.value }))
                                                }
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* ♻️ CLEAR */}
                                    {/* <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col> */}
                                </Row>
                            </div>                            {/* Summary Statistics Box */}

                            <table className="table table-hover table-striped table-bordered" style={{ fontSize: '0.8rem' }}>
                                <thead className="thead-light">
                                    <tr>
                                        {/* Add checkbox column */}
                                        <th className="align-middle text-center" width="20">
                                            <div className="form-check">
                                                <Input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Only select deliveries that are in LIVRE status
                                                            const deliveredIds = list
                                                                .filter(bl => bl.status === 'LIVRE' && !bl.estFacture)
                                                                .map(bl => bl.id);
                                                            setCheckedDeliveries(deliveredIds);
                                                        } else {
                                                            setCheckedDeliveries([]);
                                                        }
                                                    }}
                                                    checked={
                                                        checkedDeliveries.length > 0 &&
                                                        checkedDeliveries.length === list.filter(bl => bl.status === 'LIVRE' && !bl.estFacture).length
                                                    }
                                                />
                                            </div>
                                        </th>
                                        <th className="align-middle text-center">{t('delivery.numero')}</th>
                                        <th className="align-middle text-center">{t('delivery.bcNumero')}</th>
                                        <th className="align-middle text-center">{t('commande.client')}</th>
                                        <th className="align-middle text-center">{t('delivery.chantier')}</th>
                                        <th className="align-middle text-center">{t('common.user')}</th>
                                        <th className="align-middle text-center">{t('commande.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('delivery.dateOperation')}</th>
                                        <th className="align-middle text-center">{t('delivery.commercial')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('devis.montantHT')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTVA')}</th>
                                        <th className="align-middle text-center">{t('reglement.montantPaye')}</th>
                                        <th className="align-middle text-center">{t('delivery.status')}</th>
                                        <th className="align-middle text-center">{t('delivery.accuse')}</th>
                                        <th className="align-middle text-center">{t('delivery.regle')}</th>
                                        <th className="align-middle text-center">{t('delivery.facture')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((bl) => (
                                        <tr key={bl.id}>
                                            {/* Add checkbox for each row */}
                                            <td className="align-middle text-center">
                                                {bl.status === 'LIVRE' && !bl.estFacture && (
                                                    <Input
                                                        type="checkbox"
                                                        checked={checkedDeliveries.includes(bl.id)}
                                                        onChange={() => handleCheckboxChange(bl.id)}
                                                    />
                                                )}
                                            </td>
                                            <td className="align-middle text-center">{bl.numero}</td>
                                            <td className="align-middle text-center">{bl.commandeNumero || '-'}</td>
                                            <td className="align-middle text-center">
                                                {bl.clientNom || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">{bl.chantierNom || 'N/A'}</td>
                                            <td className="align-middle text-center">{bl.createdBy}</td>
                                            <td className="align-middle text-center">{bl.createdAt || 'N/A'}</td>
                                            <td className="align-middle text-center">{bl.dateOperation || 'N/A'}</td>
                                            <td className="align-middle text-center">{bl.commercialNom || 'LOCAL'}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantTotalHT, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantTotalTaxe, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantPaye, false)}</td>
                                            <td className="align-middle text-center">
                                                {bl.status === 'EN_PREPARATION' && (
                                                    <span className="badge bg-warning">{t('delivery.enpreparation')}</span>
                                                )}
                                                {bl.status === 'EN_COURS' && (
                                                    <span className="badge bg-secondary">{t('delivery.encours')}</span>
                                                )}
                                                {bl.status === 'LIVRE' && (
                                                    <span className="badge bg-success">{t('delivery.livre')}</span>
                                                )}
                                                {bl.status === 'RETOUR' && (
                                                    <span className="badge bg-danger">{t('delivery.retourne')}</span>
                                                )}
                                                 {bl.status === 'ANNULE' && (
                                                    <span className="badge bg-danger">{t('delivery.annule')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={bl.accuse}
                                                    readOnly
                                                />
                                            </td>
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={bl.estRegle}
                                                    readOnly
                                                />
                                            </td>
                                            {/* Add facture status column */}
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={bl.estFacture}
                                                    readOnly
                                                />
                                            </td>

                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    {/* Add dropdown for PDF options */}
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle caret color="secondary" size="sm" className="me-1">
                                                            <FaFilePdf />
                                                        </DropdownToggle>

                                                        <DropdownMenu>
                                                            {/* ===== A4 ===== */}
                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', true, 'A4')}
                                                            >
                                                                📄 BL A4 – avec prix
                                                            </DropdownItem>

                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', false, 'A4')}
                                                            >
                                                                📄 BL A4 – sans prix
                                                            </DropdownItem>

                                                            <DropdownItem divider />

                                                            {/* ===== A5 ===== */}
                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', true, 'A5')}
                                                            >
                                                                🧾 BL A5 – avec prix
                                                            </DropdownItem>

                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', false, 'A5')}
                                                            >
                                                                🧾 BL A5 – sans prix
                                                            </DropdownItem>

                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', false, 'TH')}
                                                            >
                                                                🧾 BL Thermique
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>

                                                    {bl.status === 'EN_PREPARATION' && <Button
                                                        color="success"
                                                        title={t('bonLivraison.livrer')}
                                                        onClick={() => handleLivrerBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}
                                                    {bl.status === 'LIVRE' && !bl.accuse && <Button
                                                        color="success"
                                                        title={t('bonLivraison.accuser')}
                                                        onClick={() => handleAccuseBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}
                                                    <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        onClick={() => handleEdit(bl)}
                                                        size="sm"
                                                        className="me-1"
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                    {/*<Button
                                                        color="danger"
                                                        title={t('commande.cancel')}
                                                        //onClick={() => handleDeleteDevis(commande.id)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaTrash />
                                                    </Button> */}
                                                    {bl.status === 'EN_PREPARATION' && <Button color="danger" size="sm" className="px-2 py-1">
                                                        <FaTrash size={12} onClick={() => handleAnnulerBL(bl)} />
                                                    </Button>}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {list.length === 0 && (
                                        <tr>
                                            <td colSpan="18" className="text-center py-4">
                                                <div className="text-muted">{t('delivery.noBL')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="9" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalHT || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTaxe || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantPaye || 0), 0), false)}</td>
                                        <td colSpan="5"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseModal}>{selectedBonLivraison ? `${t('bonLivraison.edit')} N° ${selectedBonLivraison.numero}` : t('bonLivraison.new')}</ModalHeader>
                <ModalBody>
                    <BonLivraisonForm bonLivraison={selectedBonLivraison} onClose={handleCloseModal} />
                </ModalBody>
            </Modal>

            {/* Add Invoice Modal */}
            <Modal isOpen={showInvoiceModal} toggle={handleCloseInvoiceModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseInvoiceModal}>
                    {t('facture.newInvoice')}
                </ModalHeader>
                <ModalBody>
                    {invoice && (
                        <InvoiceForm
                            initialValues={invoice}
                            onClose={handleCloseInvoiceModal}
                        />
                    )}
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default DeliveryList;



